import { render } from "./Minter.vue?vue&type=template&id=b12f8e00"
import script from "./Minter.vue?vue&type=script&lang=js"
export * from "./Minter.vue?vue&type=script&lang=js"

import "./Minter.vue?vue&type=style&index=0&id=b12f8e00&lang=scss"

import exportComponent from "/Users/giovannivignone/VSCodeProjects/mintSiteAMJ-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__